import React from 'react';
import PropTypes from 'prop-types';


const Button = (props) => {
    const { type = '', onSubmitHandler, displayLabel = '', disabled = false } = props;
    return (
        <button
            type={type}
            onClick={onSubmitHandler}
            className="b2c__loginwrap--submitbtn"
            disabled={disabled}
        >
            {displayLabel}
        </button>
    )
}

Button.propTypes = {
    type: PropTypes.string.isRequired
}

export default Button;